import PropTypes from "prop-types";
import { useContext } from "react";
import {
  CurrencyContext,
  getExchangeRatesFromStorage,
} from "../umbilical_tools";

const build_type = import.meta.env.VITE_APP_BUILD || "staging";

type getExchangedPriceProps = {
  price: number | string;
  priceCurrency: string;
  settedCurrency: string;
  withDecimals?: boolean;
};
export function getExchangedPrice({
  price,
  priceCurrency,
  settedCurrency,
  withDecimals = true,
}: getExchangedPriceProps) {
  if (typeof price == "string") {
    var prc = parseFloat(price);
  } else {
    prc = price;
  }
  const exchangeRates = getExchangeRatesFromStorage();

  let excRate = 1;
  var euroPrice = 0;
  var newPrice = prc;
  if (exchangeRates && priceCurrency !== settedCurrency) {
    euroPrice =
      priceCurrency !== "EUR" ? prc / exchangeRates.rates[priceCurrency] : prc;

    if (settedCurrency !== exchangeRates.base_currency) {
      excRate = exchangeRates.rates[settedCurrency];
    }
    newPrice = gaussianRounding(excRate * euroPrice, withDecimals ? 2 : 0);
  }
  return withDecimals ? parseFloat(newPrice.toFixed(2)) : newPrice;
}

export const CurrencyExcHoc = (WrappedComponent: any) => {
  function Comp(props: any) {
    const { price = 0.0, currency: priceCurrency = "EUR" } = props;
    const { currency: settedCurrency } = useContext(CurrencyContext);

    const newPrice = getExchangedPrice({
      price,
      priceCurrency,
      settedCurrency,
      withDecimals: true,
    });

    return (
      <WrappedComponent {...props} price={newPrice} currency={settedCurrency} />
    );
  }
  Comp.propTypes = {
    price: PropTypes.number.isRequired,
    currency:
      build_type === "staging" ? PropTypes.string : PropTypes.string.isRequired,
    customStyles: PropTypes.object,
  };

  return Comp;
};

export function gaussianRounding(n: number, d = 2) {
  var x = n * Math.pow(10, d);
  var r = Math.round(x);
  var br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
  return br / Math.pow(10, d);
}
